"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSkeleton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const row_1 = require("../row");
const styles_1 = require("./styles");
exports.CardSkeleton = (0, react_1.forwardRef)(({ content }, ref) => {
    return ((0, jsx_runtime_1.jsx)(row_1.Row, { ref: ref, width: "100%", alignItems: "flex-start", justifyContent: "space-between", children: content.map(({ columnProps, columnWidth }, columnIndex) => {
            return ((0, jsx_runtime_1.jsx)(styles_1.StyledCardSkeletonBox, { gap: "8px", xs: columnWidth[3], sm: columnWidth[2], md: columnWidth[1], lg: columnWidth[0], children: columnProps.map((rowProps, index) => {
                    return (0, jsx_runtime_1.jsx)(styles_1.SkeletonRowItem, { width: rowProps }, index);
                }) }, columnIndex));
        }) }));
});
exports.CardSkeleton.displayName = 'CardSkeleton';
exports.default = exports.CardSkeleton;
//# sourceMappingURL=card-skeleton.js.map